export default {"src":"/_next/static/media/greenCircle.2c617c12.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};